import { IMarketer } from '@/shared/model/marketer.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import RestaurantCategoryService from '@/shared/services/restaurant-category.service';
import RestaurantWorkingTimesService from '@/shared/services/restaurant-working-times.service';
import DeliverySpecService from '@/shared/services/delivery-spec.service';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { ISupportStore } from './types';
import { IRestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IUser } from '@/shared/model/user.model';

const restaurantCategoryService = new RestaurantCategoryService();
const restaurantWorkingTimesService = new RestaurantWorkingTimesService();
const deliverySpecService = new DeliverySpecService();

export const actions: ActionTree<ISupportStore, RootState> = {
  setTab({ commit }, newTab: string): void {
    commit('setTab', newTab);
  },
  setDrawer({ commit }, newDrawer: boolean): void {
    commit('setDrawer', newDrawer);
  },
  setMarketer({ commit }, newMarketer: IMarketer): void {
    commit('setMarketer', newMarketer);
  },
  setMarketerDialog({ commit }, newMarketerDialog: boolean): void {
    commit('setMarketerDialog', newMarketerDialog);
  },
  setNewMarketer({ commit }, newMarketer: IMarketer): void {
    commit('setNewMarketer', newMarketer);
  },
  setNewMarketerDialog({ commit }, newMarketerDialog: boolean): void {
    commit('setNewMarketerDialog', newMarketerDialog);
  },
  async setRestaurant({ commit }, newRestaurant: IRestaurant): Promise<boolean> {
    const restaurantCategories = await restaurantCategoryService.getRestaurantCategories(newRestaurant.id);
    const restaurantWorkingTimes = await restaurantWorkingTimesService.getRestaurantWorkingTimes(newRestaurant.id);
    const deliverySpecs = await deliverySpecService.getDeliverySpecs(newRestaurant.id);
    newRestaurant.restaurantCategories = restaurantCategories;
    newRestaurant.restaurantWorkingTimes = restaurantWorkingTimes;
    newRestaurant.deliverySpecs = deliverySpecs;
    commit('setRestaurant', newRestaurant);
    return true;
  },
  setDeliverySpecs({ commit }, newDeliverySpecs: IDeliverySpec[]): void {
    commit('setDeliverySpecs', newDeliverySpecs);
  },
  setRestaurantDialog({ commit }, newRestaurantDialog: boolean): void {
    commit('setRestaurantDialog', newRestaurantDialog);
  },
  setRestaurantWorkingTimes({ commit }, newRestaurantWorkingTimes: IRestaurantWorkingTimes[]): void {
    commit('setRestaurantWorkingTimes', newRestaurantWorkingTimes);
  },
  async setNewRestaurant({ commit, dispatch }, newRestaurant: IRestaurant) {
    const restaurant = await dispatch('retrieveRestaurantData', newRestaurant);
    commit('setNewRestaurant', restaurant);
    return true;
  },
  setNewRestaurantDialog({ commit }, newRestaurantDialog: boolean): void {
    commit('setNewRestaurantDialog', newRestaurantDialog);
  },
  async retrieveRestaurantData(context, restaurant: IRestaurant): Promise<IRestaurant> {
    if (restaurant.id) {
      const restaurantCategories = await restaurantCategoryService.getRestaurantCategories(restaurant.id);
      const restaurantWorkingTimes = await restaurantWorkingTimesService.getRestaurantWorkingTimes(restaurant.id);
      const deliverySpecs = await deliverySpecService.getDeliverySpecs(restaurant.id);
      restaurant.restaurantCategories = restaurantCategories;
      restaurant.restaurantWorkingTimes = restaurantWorkingTimes;
      restaurant.deliverySpecs = deliverySpecs;
    }
    return restaurant;
  },
  addRestaurantWorkingTime({ commit }, payload): void {
    commit('addRestaurantWorkingTime', payload);
  },
  removeRestaurantWorkingTime({ commit }, i: number): void {
    commit('removeRestaurantWorkingTime', i);
  },
  addDeliverySpec({ commit }): void {
    commit('addDeliverySpec');
  },
  removeDeliverySpec({ commit }, i: number): void {
    commit('removeDeliverySpec', i);
  },
  updateRestaurantStateMember({ commit }, payload): void {
    commit('updateRestaurantStateMember', payload);
  },
  setSupport({ commit }, newSupport: IUser): void {
    commit('setSupport', newSupport);
  },
  setSupportDialog({ commit }, newSupportDialog: boolean): void {
    commit('setSupportDialog', newSupportDialog);
  },
  setUnregisteredRestaurant({ commit }, newUnregisteredRestaurant: IUser): void {
    commit('setUnregisteredRestaurant', newUnregisteredRestaurant);
  },
  setUnregisteredRestaurantDialog({ commit }, newUnregisteredRestaurantDialog: boolean): void {
    commit('setUnregisteredRestaurantDialog', newUnregisteredRestaurantDialog);
  },
  setUpdatedRestaurant({ commit }, newUpdatedRestaurant: IUser): void {
    commit('setUpdatedRestaurant', newUpdatedRestaurant);
  },
  setUpdatedRestaurantDialog({ commit }, newUpdatedRestaurantDialog: boolean): void {
    commit('setUpdatedRestaurantDialog', newUpdatedRestaurantDialog);
  },
  setUnregisteredMarketer({ commit }, newUnregisteredMarketer: IUser): void {
    commit('setUnregisteredMarketer', newUnregisteredMarketer);
  },
  setUnregisteredMarketerDialog({ commit }, newUnregisteredMarketerDialog: boolean): void {
    commit('setUnregisteredMarketerDialog', newUnregisteredMarketerDialog);
  },
};
